export const API_ROOT = window.__env.API_ROOT
export const BASE_URL = window.__env.BASE_URL
export const PANEL_LOCATION = window.__env.PANEL_LOCATION
export const EXTENSION_API_ROOT = window.__env.EXTENSION_API_ROOT
